<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1">
            <el-row>
              <el-col :md="10" :lg="8">
                <el-date-picker v-model="activity_at" type="daterange" start-placeholder="开始时间" ange-separator="至" end-placeholder="结束时间" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="updateDateChange" size="small"></el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="10" :lg="10">
                <el-input :rows="1" placeholder="多个货号之间使用英文逗号 ',' 分隔" v-model="params.item_bns" clearable size="small">
                  <el-button slot="append" icon="el-icon-search" @click="goodsSearch"></el-button>
                </el-input>
              </el-col>
              <el-col :md="10" :lg="10">
                <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="download">导出</el-button>
              </el-col>
            </el-row>
            <el-table :data="list" style="width: 100%" v-loading="loading" element-loading-text="数据加载中">
                <el-table-column prop="seckill_id" label="活动ID" width="90"></el-table-column>
                <el-table-column prop="activity_name" label="活动名称" width="260"></el-table-column>
                <el-table-column prop="number" label="全平台适用" width="90">
                  <template slot-scope="scope">
                    {{ scope.row.distributor_id ? '否' : '是' }}
                  </template>
                </el-table-column>
                <el-table-column prop="item_bn" label="商品货号" width="90"></el-table-column>
                <el-table-column prop="item_title" label="商品名称"></el-table-column>
                <el-table-column prop="activity_price" label="商品售价" width="120">
                  <template slot-scope="scope">
                    <span style="color: #67c23a;">￥{{ scope.row.price / 100 }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="activity_price" label="活动价" width="120">
                  <template slot-scope="scope">
                    <span style="color: #f56c6c;">￥{{ scope.row.activity_price / 100 }}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="name" label="店铺名称"></el-table-column> -->
                <!-- <el-table-column prop="market_price" label="商品售价" width="120">
                  <template slot-scope="scope">
                    ￥{{ scope.row.price / 100 }}
                  </template>
                </el-table-column> -->
                <!-- <el-table-column prop="area_market_price" label="SKU售价" width="120">
                  <template slot-scope="scope">
                    ￥{{ scope.row.sku_price / 100 }}
                  </template>
                </el-table-column> -->
                <el-table-column prop="activity_start_time" label="开始时间">
                  <template slot-scope="scope">
                    {{ scope.row.activity_start_time | datetime('yyyy-MM-dd hh:mm:ss') }}
                  </template>
                </el-table-column>
                <el-table-column prop="activity_end_time" label="结束时间">
                  <template slot-scope="scope">
                    {{ scope.row.activity_end_time | datetime('yyyy-MM-dd hh:mm:ss') }}
                  </template>
                </el-table-column>
                <el-table-column prop="activeList" label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" @click="toActivity(scope.row.seckill_id)">查看活动</el-button>
                  </template>
                </el-table-column>
            </el-table>
            <div class="content-center content-top-padded">
              <el-pagination
                  background
                  layout="total, sizes, prev, pager, next"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
                  :current-page.sync="params.page"
                  :page-sizes="[20,50,100,200,500]"
                  :total="total_count"
                  :page-size="params.pageSize">
              </el-pagination>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
import { preLimitedtimesale, limitedtimesaleExport } from '@/api/goods'
export default {
    data() {
      return {
        loading: false,
        activity_at: [],
        params: {
          page: 1,
          pageSize: 20,
          item_bns: '',
        },
        total_count: 0,
        list: [],
      }
    },
    methods: {
      download() {
        limitedtimesaleExport(this.params).then(res => {
          if (res.data.data.status == true) {
            window.location.href = res.data.data.url
            this.$message.success('导出成功')
          } else {
            this.$message.error(res.data.msg)
          }
        })
      },
      updateDateChange(date) {
        this.params.start_time = date[0]
        this.params.end_time = date[1]
        this.getItemSkuInfo()
      },
      getItemSkuInfo() {
        this.loading = true
        console.log(this.params)
        preLimitedtimesale(this.params).then(res => {
          this.loading = false
          this.list = res.data.data.list
          this.total_count = res.data.data.total_count
        })
      },
      goodsSearch() {
        this.params.page = 1
        this.getItemSkuInfo()
      },
      handleSizeChange(pageSize) {
        this.params.page = 1
        this.params.pageSize = pageSize
        this.getItemSkuInfo()
      },
      handleCurrentChange(page_num) {
        this.params.page = page_num
        this.getItemSkuInfo()
      },
      // 跳转到活动详情
      toActivity(activity_id) {
        this.$router.push({path: '/marketing/limitedtimesale/limitedtimesale_editor/' + activity_id})
        this.$router.push({path: this.matchHidePage('editor/') + row.limit_id, query: {copy_flag: true}})
      },
    },
    mounted() {
      this.getItemSkuInfo()
    }
  }
</script>




// WEBPACK FOOTER //
// list.vue?1bce8b48